(function() {
    'use strict';

    angular
        .module('dentist')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
    
    function isLocalStorageNameSupported() {
  	  try {
  		localStorage.setItem('test', '1');
  		if (localStorage.getItem('test') != '1') return false;
  		localStorage.removeItem('test');
        return true;
  	  } catch (error) {
  	    return false;
  	  }
  	}

    function stateConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        
//        var isStandalone = (window.location.pathname == '/booking/'); // standalone: not inside a practice-profile (platform desktop), and not platform mobile
        var isStandalone = false;
        
        $stateProvider
        .state('index', {
            url: "/{city}/{profilePath}?treatmentId&q&utm_source&practitionerId&expanded&date&scroll",
            //abstract: true,
            //template: '<ui-view/>',
            params: {
                standalone: false,
                practiceId: null,
                practice: null
            },
            resolve: {
              practiceId: function(dentistService, $stateParams) {
                  /*return dentistService.getAllPracticeBusinessCards($stateParams.city)
                      .then (function (result) {
                          var id = result.data.find(function (practice) { return practice.profilePath === $stateParams.profilePath; } ).id;
                          $stateParams.practiceId = id;
                          return id;
                      });
                      */
                  if ($stateParams.practice) {
                      return $stateParams.practice.id;
                  }
                  
                  return dentistService.getPracticeProfileWithPublishedTreatmentExperiencesAndPublishedReponses($stateParams.profilePath)
                      .then (function (result) {
                          $stateParams.practice = result.data;
                          $stateParams.practiceId = $stateParams.practice.id;
                          return $stateParams.practiceId;
                      })
                      .catch(function (error) {
                        console.log("Error while getting profile for path:", error);
                      });
               }
            },
            onEnter: function($stateParams, $rootScope) {
            	
                function safeNormalize(str) {
                    if (!String.prototype.normalize) { // IE11...
                        return str;
                    } else {
                        return str.normalize();
                    }
                }

                if (!$stateParams.practice || $stateParams.practice.location != $stateParams.city) {
                    // no profile found for path, or practice.location does not match city: add noindex.
                    var tag = document.createElement('meta'); tag.name = 'robots'; tag.content = 'noindex';
                    document.head.appendChild(tag);
                    var text = document.createElement('custom');
                    text.innerText = "Die von Ihnen gesuchte Seite konnte leider nicht gefunden werden. Bitte wählen Sie eines der untenstehenden Themen:";
                    $('#profile-body').append(text);
                    throw "404 Not Found";
                }

                var isMobile = window.screen.width < 768;
                if ('c' === $stateParams.q && isMobile) { // if source is comparis and we are on Mobile, we switch to the platformBooking
                    window.location = '/platformBooking/#/?practiceId=' + $stateParams.practice.id + '&q=c&utm_source=' +
                    $stateParams.utm_source + '&practitionerId=' + $stateParams.practitionerId; // TODO include those (for Comparis) as well: treatmentId&date&scroll
                }

                var cityRegion = window.cityRegion;

                var mapCoordX = $stateParams.practice.coordinates.split(',')[0];
                var mapCoordY = $stateParams.practice.coordinates.split(',')[1];
                var practiceInCity = safeNormalize($stateParams.practice.name) + " in " + safeNormalize($stateParams.practice.addressCity);
                var title = practiceInCity + ($stateParams.practice.teaser ? " - Zumedo" : " - Termin buchen - Zumedo");
                var teaserDescription = "Hier finden Sie Informationen zu Besuchserlebnissen und zum Standort der " + practiceInCity + ". Zumedo stellt Informationen zu Terminen, Fachgebieten, Bewertungen usw. zur Verfügung.";
                var description = $stateParams.practice.teaser ? teaserDescription : safeNormalize($stateParams.practice.name) + " - " + safeNormalize($stateParams.practice.locationDescription) + " - vereinbaren Sie ihren Termin online";

                $rootScope.isExpanded = (!!$stateParams.expanded || $stateParams.expanded === '');
                $rootScope.pageTitle = title;
                $rootScope.metaDescription = description;
                $rootScope.metaKeywords = "Zahnarzt, Zahnarztpraxis, Zahnarztzentrum, Dentalhygiene, Krone, Zürich, Bern, Basel";
                $rootScope.metaGeoRegion = "CH" + (cityRegion[$stateParams.practice.location] ? '-' + cityRegion[$stateParams.practice.location] : '');
                $rootScope.metaGeoPlacename = safeNormalize($stateParams.practice.addressCity);
                $rootScope.metaGeoPosition = mapCoordX + ";" + mapCoordY;
                $rootScope.metaICBM = mapCoordX + "," + mapCoordY;
                $rootScope.metaOgTitle = title;
                $rootScope.metaOgDescription = description;
                $rootScope.metaOgUrl = "https://www.zumedo.ch/zahnarzt/" + $stateParams.practice.location + "/" + $stateParams.practice.profilePath;
                $rootScope.metaOgSiteName = title;
                $rootScope.canonicalLink = "https://www.zumedo.ch/zahnarzt/" + $stateParams.practice.location + "/" + $stateParams.practice.profilePath;
            },
 			views: {
				 'profile@': {
					 templateUrl: 'templates/profile.html',
				 },
				 '@': {
					 template: '<ui-view/>',
					 controller: function($stateParams, $state, practiceId) {

    					     // if teaser profile, don't initialize booking part
    					     if ($stateParams.practice && ($stateParams.practice.teaser == true)) {
    					         return;
    					     }

			            	// check local storage support
			            	if (!isLocalStorageNameSupported()) {
			            		// state.go warning site
			            		$state.go('warning');
			            		
			            		return;
			            	}

			            	// if source is comparis, we want to scroll to the bottom
			            	var scrollTarget = ('c' === $stateParams.q ? 'bottom-scroll' : $stateParams.scroll);

			                //var practiceId = practice;
                           $state.go('home', { standalone: isStandalone, practiceId: practiceId, treatmentId: $stateParams.treatmentId,
                                           practitionerId: $stateParams.practitionerId, expanded: $stateParams.expanded, date: $stateParams.date,
                                            scroll: scrollTarget, q: $stateParams.q, utm_source: $stateParams.utm_source });
			            }
				 }
 			},
            
        })

        .state('home', {
            //url: "/home?practiceId",
            parent: 'index',
            params: {
                practiceId: null
             },
            cache: true,
            //templateUrl: "templates/home.html",
 			views: {
			 '@': {
				 templateUrl: 'templates/home.html',
			 }
			}
            //controller: 'homeController'
        })

        .state('detail', {
            //url: "/detail",
            parent: 'index',
            params: {
            	ecommerceObject: null
            },
            //templateUrl: "templates/detail.html"
            views: {
            	'@': {
            		templateUrl: 'templates/detail.html',
            	}
            }
            //controller: 'detailController'
        })
        
       .state('done', {
            //url: "/done",
            parent: 'index',
            //templateUrl: "templates/done.html"
            views: {
            	'@': {
            		templateUrl: 'templates/done.html',
            	}
            }
            //controller: 'doneController'
       })

       .state('error', {
            parent: 'index',
            views: {
            	'@': {
            		templateUrl: 'templates/error.html',
            	}
            }
       })

       .state('warning', {
            parent: 'index',
        	views: {
            	'@': {
            		templateUrl: "templates/warning.html"
            	}
            }
       });

     //$urlRouterProvider.otherwise("/");
     /*$urlRouterProvider.otherwise(function($injector, $location) {
         // if there is a path that matches an html element id, we assume the location to be an anchor hash link and scroll to it, as soon as the document is ready
         var pathWithoutLeadingSlash = $location.path().substring(1);
         if (pathWithoutLeadingSlash != '') {
             var anchor = $('#' + pathWithoutLeadingSlash);
             if (anchor.length) {
                 $(function() {
                     $('html, body').animate({
                         scrollTop: anchor.offset().top
                     }, 900, function() {}); 
                 });
             }
         }
         return '/';
     });*/


     $locationProvider.html5Mode({enabled: true, rewriteLinks: false});
     
    }

})();
